import { environment } from '@trello/config';
import { currentLocale, languageParts } from '@trello/locale';

import { getTopTemplates } from './getTopTemplates';
import { useTemplatePickerContainerGalleryQuery } from './TemplatePickerContainerGalleryQuery.generated';
import { useTemplatePickerContainerMyTemplatesQuery } from './TemplatePickerContainerMyTemplatesQuery.generated';
import { useTemplatePickerStarredQuery } from './TemplatePickerStarredQuery.generated';

interface UseTemplatePickerContainerPreloaderProps {
  skip?: boolean;
}

export const useTemplatePickerPreloader = ({
  skip = false,
}: UseTemplatePickerContainerPreloaderProps) => {
  const topTemplates: { [key: string]: string[] } =
    getTopTemplates(environment);

  const language = languageParts(currentLocale).language;
  let topTemplatesList: string[] = [];

  if (topTemplates[currentLocale]) {
    topTemplatesList = topTemplates[currentLocale];
  } else if (topTemplates[language]) {
    topTemplatesList = topTemplates[language];
  } else {
    topTemplatesList = topTemplates['en'];
  }

  const templatePickerContainerGalleryQueryResult =
    useTemplatePickerContainerGalleryQuery({
      variables: {
        boardIds: topTemplatesList,
      },
      skip,
      waitOn: ['None'],
    });

  const templatePickerContainerMyTemplatesQueryResults =
    useTemplatePickerContainerMyTemplatesQuery({
      skip,
      waitOn: ['None'],
    });

  const templatePickerStarredQueryResults = useTemplatePickerStarredQuery({
    skip,
    waitOn: ['None'],
  });

  return {
    templatePickerContainerGalleryQueryResult,
    templatePickerContainerMyTemplatesQueryResults,
    templatePickerStarredQueryResults,
  };
};
